/* eslint-disable @typescript-eslint/no-explicit-any */
import to from "await-to-js";
import newColorAxiosInstance from "@/common-components-src/api/new-color-axiosInstance";

export const thirdLoginApi = async (requestData: any): Promise<any> => {
  return await to<any>(
    newColorAxiosInstance
      .post<any>("user_account_loginByOuterAuth", undefined, {
        params: { ...requestData },
        cthr: "1",
      })
      .then((response: any) => response.data)
      .catch((err: any) => err),
  );
};
